import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function CTASection({
  title = "Ready to Strengthen Your Organization's Systems, Security and Resilience?",
  description = "Tell us about your objectives and challenges. Our team will review your enquiry and arrange an initial consultation focused on your environment.",
}) {
  return (
    <section className="relative bg-gradient-to-br from-navy via-navy-800 to-navy-900 overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 grid-pattern-dark" aria-hidden="true" />
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-bright/10 blur-3xl" aria-hidden="true" />
      <div className="container-site relative py-16 sm:py-24 text-center">
        <Reveal>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white max-w-3xl mx-auto">
            {title}
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-300 max-w-2xl mx-auto">{description}</p>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              data-testid="cta-request-consultation-btn"
              className="inline-flex items-center gap-2 bg-teal hover:bg-teal-dark text-white font-semibold px-7 py-3.5 rounded-full transition-colors duration-200"
            >
              Request a Consultation
              <ArrowRight size={16} aria-hidden="true" />
            </Link>
            <Link
              to="/contact"
              data-testid="cta-contact-team-btn"
              className="inline-flex items-center gap-2 border border-white/25 hover:border-white/50 hover:bg-white/5 text-white font-semibold px-7 py-3.5 rounded-full transition-colors duration-200"
            >
              Contact Our Team
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
